import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ComplaintState {
  notRepliedCount: number;
}

const initialState: ComplaintState = {
  notRepliedCount: 0
};

const complaintSlice = createSlice({
  name: 'complaint',
  initialState,
  reducers: {
    setNotRepliedCount: (state, action: PayloadAction<number>) => {
      state.notRepliedCount = action.payload;
    }
  }
});

export const { setNotRepliedCount } = complaintSlice.actions;
export default complaintSlice.reducer;
